export const isDeprecatedContent = html => html.includes('class=\"container');
